export default __webpack_public_path__ + "stumbler-screens_tablet.b61e4a6c.png";